import { createSelector } from 'reselect';
import { filter } from 'lodash';
import { toSelectionFormat } from '../../lib/collection.utils';
import { timeToMs } from '../../lib/date.utils';
import { bufferArrayToUtf8 } from '../../lib/string.utils';

export const items = state => state.events.list.items;
const list = state => state.events.list;
const selected = state => state.events.list.selected;

// SELECT EVENT
export const eventsOptionsSelector = createSelector(items, events => {
    return events.map(ev => ({ value: ev.id, label: ev.name }));
});
export const selectedEventIdSelector = createSelector(selected, selected => selected);
export const eventsFetchedSelector = createSelector(list, events => events.fetched);
export const eventsFetchingSelector = createSelector(list, events => events.fetching);
export const selectedEventSelector = createSelector(items, selected, (list, selected) => {
    const selectedEvent = filter(list, ev => ev.id === selected);
    return selectedEvent[0] || {};
});

export const eventsFromOrganizations = (withContext, context, orgIds, events) => {
    const toFilter = withContext ? [context] : orgIds;
    return toSelectionFormat(filter(events, e => toFilter.includes(e.organizationId)));
};

export const apiDataToState = data => {
    if (data.start) {
        data.start = timeToMs(data.start);
    }
    if (data.end) {
        data.end = timeToMs(data.end);
    }
    data.defaultSignature = bufferArrayToUtf8((data.defaultSignature && data.defaultSignature.data) || []);
    data.performanceSignature = bufferArrayToUtf8((data.performanceSignature && data.performanceSignature.data) || []);

    return data;
};
